import PropTypes from 'prop-types';

// UTILS
import { formatDateAndTime } from './commons/date';

export const getOrderStatus = (status) => {
  const statusMap = [
    {
      values: [1, 2, 12],
      label: 'Confirmado',
      color: 'success-color',
    },
    {
      values: [4, 9, 17],
      label: 'Pendente',
      color: 'warning-color',
    },
    {
      values: [3, 18, 19],
      label: 'Estornado',
      color: 'default-color',
    },
    {
      values: [7],
      label: 'Estornado parcialmente',
      color: 'default-color',
    },
    {
      values: [6, 8, 10, 11, 13, 14, 15, 16],
      label: 'Cancelado',
      color: 'error-color',
    },
  ];

  const matchedStatus = statusMap.find((item) => item.values.includes(status));

  return matchedStatus || null;
};
getOrderStatus.propTypes = {
  status: PropTypes.number,
};

export const normalizeOrderTracking = (trackingStatus) => {
  const normalizedData = [];

  if (trackingStatus) {
    trackingStatus.map((item) => {
      const normalizedItem = {
        title: item.name,
        description: formatDateAndTime(item.when),
        statusCode: item.status,
      };

      normalizedData.push(normalizedItem);
    });
  }

  return normalizedData;
};
normalizeOrderTracking.propTypes = {
  trackingStatus: PropTypes.arrayOf(
    PropTypes.shape({
      when: PropTypes.string,
      status: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
};

export const getTrackingCurrentStep = (normalizedTrackingStatus) => {
  let lastIndex = -1;

  /* eslint-disable */
  for (let i = 0; i < normalizedTrackingStatus.length; i++) {
    const item = normalizedTrackingStatus[i];

    if (item.description !== null && item.description !== undefined && item.description !== '') {
      lastIndex = i;
    }
  }

  return lastIndex;
};
getTrackingCurrentStep.propTypes = {
  normalizedTrackingStatus: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      statusCode: PropTypes.string,
    }),
  ),
};

export function getTrackingStatus(currentIndex, normalizedTrackingStatus) {
  const currentStatus = normalizedTrackingStatus[currentIndex];

  if (currentStatus && currentStatus.statusCode) {
    switch (currentStatus.statusCode) {
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
        return 'finish'
      case '6':
      case '7':
      case '8':
      case '9':
      case '10':
        return 'error'
      default:
        return ''
    }
  }
};
getTrackingStatus.propTypes = {
  currentIndex: PropTypes.number,
  normalizedTrackingStatus: PropTypes.arrayOf(
      PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          statusCode: PropTypes.string,
      }),
  ),
};

export const reduceOrderItems = (orderItems) => {
  const normalizedData = [];

  if (orderItems) {
    orderItems.forEach((vendor) => {
      vendor.items.forEach((item) => {
        normalizedData.push({
          vendorId: vendor.vendorId,
          vendorName: vendor.vendorName,
          productName: item.name,
          productImage: item.imageUrl,
          quantity: item.quantity,
        })
      })
    })
  }

  return normalizedData;
};
